export default "__VITE_ASSET__Bf11w1dB__"